export const environment = {
  production: false,
  apiUrl: 'https://bild-services-dra3hdcnbna5ath9.westus2-01.azurewebsites.net'
};
